export { default as avatar } from './avatar-pro.png';
export { default as logo_pnj } from './logo_pnj.png';
export { default as logo } from './logo.png';
export { default as background } from './background.png';
export { default as materials } from './materials.png';
export { default as box } from './box.png';
export { default as PR_Monochromatic } from './PR_Monochromatic.png';
